import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    settlement,
    year,
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxpayerInsteadId,
    taxpayerInstead,
    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [settlement.name]: Yup.string().required(settlement.errorMsg),
  [year.name]: Yup.number().required(year.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
  .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
  .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxpayerInstead.name]: Yup.string().required(taxpayerInstead.errorMsg),
  [taxpayerInsteadId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxpayerInsteadId.invalidMsg)
    .required(taxpayerInsteadId.errorMsg),

  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
